<!--
 * @Author: chengfei
 * @Date: 2023-03-27 17:37:43
 * @LastEditTime: 2023-06-26 14:15:23
 * @LastEditors: yeyimei
 * @Description: 
 * @FilePath: \cardlan-h5-qrcode\src\components\empty.vue
-->
<template>
  <div class="flexbox_column center">
    <img
      :src="img"
      :class="boxClass"
      :style="{ 'padding-top': isTop ? '0' : '' }"
    />
    <div class="text" :style="{ 'padding-bottom': isTop ? '0' : '30px' }">
      {{ imgText }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "暂无数据",
    },
    isTop: {
      type: Boolean,
      default: false,
    },
    // 10 会员中心  //20商城
    type: {
      type: Number,
      default: 30,
    },
    bg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      img: "",
      imgText: this.text,
      boxClass: "img2",
    }
  },
  created() {
    // 10 会员中心  //20商城
    if (this.type === 10) {
      this.img =
        "https://ad-prod.oss-cn-shenzhen.aliyuncs.com/ad/scoreGift/1687749813997_94053.png"
      this.boxClass = "img1"
    } else if (this.type === 20) {
      this.img = require("@/assets/images/no-goods.png")
      this.imgText = "暂无商品"
      this.boxClass = "img2"
    } else {
      this.img = require("@/assets/images/no-data.png")
      // this.img = require('@/assets/images/empty.png')
      this.boxClass = "img2"
    }
  },
}
</script>
<style lang="scss" scoped>
.img1 {
  width: 265px;
  height: 165px;
  padding-top: 120px;
}
.img2 {
  width: 160px;
  height: 140px;
  padding-top: 120px;
}
.text {
  color: #b5b5b5;
  font-size: 14px;
}
</style>
